// Gestion du panier temporaire pour les échantillons
let sampleCart = JSON.parse(localStorage.getItem('sampleCart')) || [];
let addedProducts = new Set(sampleCart.map(item => item.product_id));

// Met à jour l'affichage du panier temporaire
function updateSampleCart() {
  const sampleList = document.getElementById('sampleList');
  const circles = document.querySelectorAll('.sample-circle');
  const addToCartBtn = document.getElementById('addToCartBtn');
  const discountMessage = document.getElementById('discountMessage');
  const errorMessage = document.getElementById('errorMessage');

  // Réinitialiser la liste
  sampleList.innerHTML = '';

  // Mettre à jour les cercles
  circles.forEach((circle, index) => {
    circle.classList.toggle('filled', index < sampleCart.length);

    // Supprimer ancien label "Gratuit"
    const wrapper = circle.parentElement;
    const existingLabel = wrapper.querySelector('.free-label');
    if (existingLabel) existingLabel.remove();

    // Ajouter "Gratuit" progressivement : à partir du 2e article
    if (sampleCart.length > 1 && index >= 1 && index < sampleCart.length) {
      const label = document.createElement('span');
      label.className = 'free-label';
      label.textContent = 'Gratuit';
      label.style.cssText = 'display:block; font-size:9px; color:#47c086; font-weight:bold; text-align:center; margin-top:2px;';
      wrapper.appendChild(label);
    }
  });

  // Afficher chaque échantillon
  sampleCart.forEach((sample, index) => {
    const li = document.createElement('li');
    li.innerHTML = `
      <input type="hidden" class="sample_id" value="${sample.variant_id}">
      <input type="hidden" class="sample_option" name="Option" value="${sample.option}">
      <input type="hidden" class="sample_pdf_url" value="${sample.pdf_url}">
      <input type="hidden" class="sample_image" value="${sample.image}">
      <input type="hidden" class="sample_product_id" value="${sample.product_id}">
      <img src="${sample.image}" alt="Échantillon de ${sample.option}">
      ${sample.option}
      <span class="remove-sample" onclick="removeSample(${index})">x</span>
    `;
    sampleList.appendChild(li);
  });

  // DÉSACTIVER LE BOUTON TANT QU'ON N'A PAS 4 ÉCHANTILLONS
  addToCartBtn.disabled = sampleCart.length !== 4;
  discountMessage.style.display = sampleCart.length === 4 ? 'block' : 'none';
  errorMessage.style.display = 'none';

  // MISE À JOUR DES BOUTONS SUR TOUTES LES PAGES
  document.querySelectorAll('.add-sample-btn').forEach(btn => {
    const productId = btn.getAttribute('data-product-id');
    if (addedProducts.has(productId)) {
      btn.classList.add('added');
      btn.textContent = 'Ajouté';
    } else {
      btn.classList.remove('added');
      btn.textContent = 'Ajouter à ma sélection';
    }
  });
}

// Afficher un message d'erreur SOUS LE H3 (dans .sample-cart-content)
function showErrorMessage(text) {
  const errorMessage = document.getElementById('errorMessage');
  errorMessage.textContent = text;
  errorMessage.style.display = 'block';

  // Masquer après 3 secondes
  clearTimeout(window.errorTimeout);
  window.errorTimeout = setTimeout(() => {
    errorMessage.style.display = 'none';
  }, 3000);
}

// Ajouter un échantillon au panier temporaire
function addSample(variantId, option, image, pdfUrl, productId) {
  if (!variantId || !option || !image || !pdfUrl || !productId) {
    console.error('Données manquantes pour ajouter l’échantillon', { variantId, option, image, pdfUrl, productId });
    showErrorMessage('Erreur : Données manquantes pour ajouter l’échantillon.');
    return;
  }

  if (sampleCart.length >= 4 && !addedProducts.has(productId)) {
    showErrorMessage('Veuillez supprimer un article de votre panier avant d\'en ajouter un nouveau.');
    return;
  }

  if (addedProducts.has(productId)) {
    // Si déjà ajouté → supprimer
    const indexToRemove = sampleCart.findIndex(item => item.product_id === productId);
    if (indexToRemove !== -1) {
      addedProducts.delete(productId);
      sampleCart.splice(indexToRemove, 1);
    }
  } else {
    // Sinon → ajouter
    addedProducts.add(productId);
    sampleCart.push({ 
      variant_id: variantId, 
      option: option, 
      image: image, 
      pdf_url: pdfUrl,
      product_id: productId
    });
  }

  localStorage.setItem('sampleCart', JSON.stringify(sampleCart));
  updateSampleCart();
}

// Supprimer un échantillon du panier temporaire
function removeSample(index) {
  const productId = sampleCart[index].product_id;
  addedProducts.delete(productId);
  sampleCart.splice(index, 1);
  localStorage.setItem('sampleCart', JSON.stringify(sampleCart));
  updateSampleCart();
}

// Ajouter les échantillons au panier Shopify
document.querySelectorAll('.ab-test-sample-add-to-cart').forEach(button => {
  button.addEventListener('click', async () => {
    const errorMessage = document.getElementById('errorMessage');
    if (sampleCart.length !== 4) {
      showErrorMessage('Veuillez ajouter 4 échantillons avant de valider.');
      return;
    }

    const sampleItems = document.querySelectorAll('#sampleList .sample_id');
    const optionItems = document.querySelectorAll('#sampleList .sample_option');
    const pdfUrlItems = document.querySelectorAll('#sampleList .sample_pdf_url');
    const imageItems = document.querySelectorAll('#sampleList .sample_image');

    let success = true;

    try {
      for (let index = 0; index < sampleItems.length; index++) {
        const sampleId = sampleItems[index].value;
        const option = optionItems[index].value;
        const pdfUrl = pdfUrlItems[index].value;
        const image = imageItems[index].value;

        if (!sampleId || !option || !pdfUrl || !image) {
          success = false;
          const errorText = `Erreur : Données manquantes pour échantillon ${index + 1}`;
          console.error(errorText, { sampleId, option, pdfUrl, image });
          showErrorMessage(errorText);
          throw new Error(errorText);
        }

        console.log('Ajout de l’échantillon ' + (index + 1), {
          id: sampleId,
          option: option,
          pdf_url: pdfUrl,
          image: image
        });

        const response = await fetch('/cart/add.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: sampleId,
            quantity: 1,
            properties: {
              'Option': option,
              '_PDF_URL': pdfUrl,
              '_sample_product_image': image
            }
          })
        });

        if (!response.ok) {
          success = false;
          const errorText = `Erreur HTTP : ${response.status} pour échantillon ${index + 1}`;
          console.error(errorText);
          showErrorMessage(errorText);
          throw new Error(errorText);
        }

        const data = await response.json();
        console.log('Données API pour échantillon ' + (index + 1), data);
      }

      // Ajouter la note
      const noteResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          note: '3 échantillons gratuits sur 4'
        })
      });

      if (!noteResponse.ok) {
        console.warn('Note non ajoutée, mais panier OK');
      }

      if (success) {
        sampleCart = [];
        addedProducts.clear();
        localStorage.removeItem('sampleCart');
        updateSampleCart();
        setTimeout(() => {
          window.location.href = '/checkout';
        }, 1000);
      }
    } catch (error) {
      console.error('Erreur lors de l\'ajout au panier:', error);
      showErrorMessage('Erreur lors de l\'ajout au panier.');
    }
  });
});

// INITIALISATION À CHAQUE CHARGEMENT DE PAGE
document.addEventListener('DOMContentLoaded', () => {
  // Recharger le panier depuis localStorage
  sampleCart = JSON.parse(localStorage.getItem('sampleCart')) || [];
  addedProducts = new Set(sampleCart.map(item => item.product_id));

  // Mettre à jour tout : pastilles, boutons, liste
  updateSampleCart();
});